__webpack_require__.p = "https://ikea.marat.qd.je/sa/ar/local-apps/alsulaiman-purchase-handler/";